/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ClassroomdisciplineSharedCompaniesQueryResponse,
  GetApiV1ClassroomdisciplineSharedCompaniesQueryParams,
  GetApiV1ClassroomdisciplineSharedCompanies401,
} from "../../types/classPlanningSharedController/GetApiV1ClassroomdisciplineSharedCompanies.ts";

function getGetApiV1ClassroomdisciplineSharedCompaniesUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/classroomdiscipline/shared/companies` as const,
  };
  return res;
}

/**
 * @description  **(Requer Authorization para autenticação)**
 * @summary Lookup de empresas ativas (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/shared/companies}
 */
export async function getApiV1ClassroomdisciplineSharedCompanies(
  params?: GetApiV1ClassroomdisciplineSharedCompaniesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ClassroomdisciplineSharedCompaniesQueryResponse,
    ResponseErrorConfig<GetApiV1ClassroomdisciplineSharedCompanies401>,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ClassroomdisciplineSharedCompaniesUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
